import { cn } from '@/lib/utils';

/**
 * Skeleton de carregamento.
 *
 * Existem 12 arquivos de Skeleton no projeto (src/components/skeleton/*) que sao
 * CODIGO MORTO - nenhum import fora deles mesmos. O padrao real hoje e bloquear
 * a tela inteira com <LoadingScreen />, o que causa flash branco a cada
 * navegacao. Este componente existe para as telas migradas usarem skeleton de
 * verdade, por regiao, em vez de bloquear tudo.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}

export { Skeleton };
